import { Component, OnInit } from '@angular/core'
import { VendorService } from '../vendor.service'
import { ToastrService } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { VendorModel } from '../vendor.model'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { MasterCommonServices } from '../../quotation/master.common.service'
import { AuthStateService } from '../../../auth-state.service'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-view-vendors',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-vendors.component.html',
  styleUrl: './view-vendors.component.css',
})
export class ViewVendorsComponent implements OnInit {
  isLoading: boolean = false
  permissions: string[] = []

  filteredVendorList: VendorModel[] = []

  filter = {
    vendorName: '',
    gstNo: '',
    address: '',
    contactNo: '',
  }

  constructor(
    private authStateService: AuthStateService,
    private vendorService: VendorService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {
    this.authStateService.permissions.subscribe((permList) => {
      this.permissions = permList
    })
  }

  ngOnInit(): void {
    if (this.masterCommonService.vendorList.length === 0) {
      this.masterCommonService.getAllVendors()

      const interval = setInterval(() => {
        if (this.masterCommonService.vendorList.length > 0) {
          this.filteredVendorList = [
            ...this.masterCommonService.vendorList,
          ]
          clearInterval(interval)
        }
      }, 100)
    } else {
      this.filteredVendorList = [...this.masterCommonService.vendorList]
    }
  }

  hasPermission(action: string): boolean {
    return this.permissions.includes(action)
  }

  applyFilters(): void {
    this.filteredVendorList =
      this.masterCommonService.vendorList.filter((vendor) => {
        return (
          (!this.filter.vendorName ||
            vendor.vendorName
              ?.toLowerCase()
              .includes(this.filter.vendorName.toLowerCase())) &&
          (!this.filter.gstNo ||
            vendor.gstNo
              ?.toLowerCase()
              .includes(this.filter.gstNo.toLowerCase())) &&
          (!this.filter.address ||
            vendor.address
              ?.toLowerCase()
              .includes(this.filter.address.toLowerCase())) &&
          (!this.filter.contactNo ||
            vendor.contactNo
              ?.toLowerCase()
              .includes(this.filter.contactNo.toLowerCase()))
        )
      })
  }

  resetFilters(): void {
    this.filter = {
      vendorName: '',
      gstNo: '',
      address: '',
      contactNo: '',
    }

    this.filteredVendorList = [...this.masterCommonService.vendorList]
  }

  viewVendor(vendor: VendorModel) {
    this.router.navigate(['/addVendor'], {
      state: {
        mode: 'view',
        vendor: vendor,
      },
    })
  }

  updateVendor(vendor: VendorModel) {
    this.router.navigate(['/addVendor'], {
      state: {
        mode: 'update',
        vendor: vendor,
      },
    })
  }

  deleteVendor(vendor: VendorModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this vendor?' },
    })

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.vendorService.deleteVendor(vendor).subscribe({
          next: () => {
            this.masterCommonService.vendorList =
              this.masterCommonService.vendorList.filter(
                (p) => p.id !== vendor.id,
              )

            this.applyFilters()

            this.toastr.success(
              'Vendor Deleted Successfully!',
              'Success',
            )
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', {
              timeOut: 15000,
              closeButton: true,
              progressBar: true,
            })
          },
        })
      }
    })
  }
}